import { useEffect, useState } from 'react';
import {
  DEFAULT_WEB_SETTINGS,
  formatPriceRupee,
  supabase,
  telHref,
  whatsappHref,
} from '../lib/webSite';

export default function useWebSettings() {
  const [settings, setSettings] = useState(DEFAULT_WEB_SETTINGS);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!supabase) return;
      try {
        const { data, error } = await supabase
          .from('web_settings')
          .select('phone, email, address, price_per_student')
          .order('updated_at', { ascending: false })
          .limit(1)
          .maybeSingle();

        if (error) throw error;
        if (!cancelled && data) {
          setSettings({
            phone: data.phone || DEFAULT_WEB_SETTINGS.phone,
            email: data.email || DEFAULT_WEB_SETTINGS.email,
            address: data.address || DEFAULT_WEB_SETTINGS.address,
            price_per_student:
              data.price_per_student ?? DEFAULT_WEB_SETTINGS.price_per_student,
          });
        }
      } catch (err) {
        console.warn('Could not load web_settings; using defaults.', err);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const phone = settings.phone;
  const email = settings.email;
  const address = settings.address;
  const priceLabel = formatPriceRupee(settings.price_per_student);
  const wa = whatsappHref(phone);
  const call = telHref(phone);

  return { phone, email, address, priceLabel, wa, call };
}
